import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, parseOptions} from '../question-helper';
import { QuestionFlowSessionStore } from '../state/question-flow-session.store';

@Component({
    selector: 'app-question-selector',
    templateUrl: './question-selector.component.html',
    styleUrls: ['./question-selector.component.scss'],
    standalone: false
})
export class QuestionSelectorComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Output() questionAnswer = new EventEmitter();

  uniqueControlName = `selector-${newGuid()}`;
  items: any[] = [];

  constructor(private questionFlowSessionStore: QuestionFlowSessionStore,) { }

  ngOnInit(): void {
    if (this.question?.options){
      this.items = parseOptions(this.question.options);
    }
  }

  getExitOption(): any {
    const exitOption = this.items.find((item: any) => item.entry_type === 'exit_option');
    if (exitOption){
      return exitOption;
    }
  }

  getClassHeaders(): any {
    return this.items?.filter((item: any) => item.entry_type === 'class_header');
  }

  getClassItems(class_id: any): any {
    return this.items?.filter((item: any) => item.entry_type === 'class_item' && item.class_id === class_id);
  }

  getBenefitsHeader(): any {
    return this.items.find((item: any) => item.entry_type === 'benefits_header');
  }

  getBenefits(): any {
    return this.items?.filter((item: any) => item.entry_type === 'benefits_item');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue){
      this.items = parseOptions(changes?.question?.currentValue?.options);
    }
  }

  checkRadio(answer: any): void {
    if (answer) {
      this.question.item_id = answer.item_id;
      this.questionFlowSessionStore.update({
        item_id: answer.item_id,
      });
      this.question.answer = JSON.stringify(answer);
      this.questionAnswer.emit(this.question);
    }
  }
  getDescriptionIndex(item: any, idx: number): string {
    if (item.description_1?.split('|')[idx])
      return item.description_1?.split('|')[idx];
    else
      return item.description_1;
  }
}
